// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33ubS","buttons":"Footer_buttons__1HZFI"};